// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"new-tab-v2-component_uk-open__mPatY","grecaptcha-badge":"new-tab-v2-component_grecaptcha-badge__HBZYN","tab-container":"new-tab-v2-component_tab-container__DJ56N","list":"new-tab-v2-component_list__iXeUn","background":"new-tab-v2-component_background__ZNXZn"};
    if(module.hot) {
      // 1750775036888
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  